// extracted by mini-css-extract-plugin
module.exports = {"md":"page_md_11xHR","ios":"page_ios_OgnSD","page":"page_page_w15AY"};